import Vue from "vue"; //引入Vue
import Router from "vue-router"; //引入vue-router
Vue.use(Router); //Vue全局使用Router
export default new Router({
  mode: "history",
  base: '/index',
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "home",
      meta: { title: "奉化极乐寺" },
      component: () => import("@/views/home/index"),
    },
      {
      path: "/Introduction",
      name: "Introduction",
      meta: { title: "奉化极乐寺" },
      component: () => import("@/views/home/Introduction"),
    },
      {
      path: "/activity",
      name: "activity",
      meta: { title: "奉化极乐寺" },
      component: () => import("@/views/home/activity"),
    },
      {
      path: "/activitycontent",
      name: "activitycontent",
      meta: { title: "奉化极乐寺" },
      component: () => import("@/views/home/activitycontent"),
    },
      {
      path: "/legal",
      name: "legal",
      meta: { title: "奉化极乐寺" },
      component: () => import("@/views/home/legal"),
    },
      {
      path: "/legalcontent",
      name: "legalcontent",
      meta: { title: "奉化极乐寺" },
      component: () => import("@/views/home/legalcontent"),
    },
        {
      path: "/404",
      component: () => import("@/views/404"),
      hidden: true,
    },
  ],
});
